import TypeToReducer from 'type-to-reducer';
import { normalize, schema } from 'normalizr';

import {
  GET_CATALOGS,
  SET_CATALOGS_PAGINATION,
  SET_CATALOGS_FILTERS,
  RESET_CATALOGS,
  TOGGLE_CATALOG,
} from 'catalogs/constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const catalog = new schema.Entity('catalogs');

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: ['name'],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  entities: { catalogs: {} },
  result: { catalogs: [] },
};

export const getPending = (state) => ({ ...state, isLoading: true, needFetch: false });

export const getFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  pagination: {
    ...state.pagination,
    limit: payload.limit,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  },
  ...normalize({ catalogs: payload.records }, { catalogs: [catalog] }),
});

export const getRejected = (state) => ({ ...state, isLoading: false });

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

export const togglePending = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    catalogs: {
      ...state.entities.catalogs,
      [meta.id]: { ...state.entities.catalogs[meta.id], isLoading: true },
    },
  },
});

export const toggleRejected = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    catalogs: {
      ...state.entities.catalogs,
      [meta.id]: { ...state.entities.catalogs[meta.id], isLoading: false },
    },
  },
});

export const toggleFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    catalogs: {
      ...state.entities.catalogs,
      [payload.catalog.id]: { ...payload.catalog, isLoading: false },
    },
  },
});

const reducers = {
  [GET_CATALOGS]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [SET_CATALOGS_PAGINATION]: setPagination,
  [SET_CATALOGS_FILTERS]: setFilters,
  [RESET_CATALOGS]: reset,
  [TOGGLE_CATALOG]: {
    [PENDING]: togglePending,
    [FULFILLED]: toggleFulfilled,
    [REJECTED]: toggleRejected,
  },
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/reducers/catalogs_list_reducers.js